import React from 'react';
import { observer, inject } from 'mobx-react';
import * as HtmlToReactParser from 'html-to-react';
import * as HtmlToReact from 'html-to-react';
import CellType from './CellType';
import jQuery from 'jquery';
import * as Util from '../../util/formUtil';
import * as DetailUtil from '../../util/public/detailUtil';
let htmlToReactParser = new HtmlToReactParser.Parser();
let processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);

@inject('globalStore', 'layoutStore')
@observer
export default class SourceLayout extends React.Component {
    componentDidMount(){
        jQuery(".excelTempDiv").find("button[name^=addbutton],input[name^=addbutton]").each(function(){
            const name = jQuery(this).attr("name");
            const detailIndex = parseInt(name.replace("addbutton", ""));
            const detailMark = "detail_"+(detailIndex+1);
            const detailObj = DetailUtil.getDetailObj(detailMark);
            if(detailObj == null)   
                return true;
            const { isadd,isdelete } = detailObj.attr;
            if(isadd === 1){
                jQuery(this).removeAttr("onclick");
                jQuery(this).bind("click", function(){
                    DetailUtil.addRow(detailMark);
                });
            }else{
                jQuery(this).remove();
            }
        });
        jQuery(".excelTempDiv").find("button[name^=delbutton],input[name^=delbutton]").each(function(){
            const name = jQuery(this).attr("name");
            const detailIndex = parseInt(name.replace("delbutton", ""));
            const detailMark = "detail_"+(detailIndex+1);
            const detailObj = DetailUtil.getDetailObj(detailMark);
            if(detailObj == null)   
                return true;
            const { isadd,isdelete } = detailObj.attr;
            if(isadd === 1 || isdelete === 1){
                jQuery(this).removeAttr("onclick");
                jQuery(this).bind("click", function(){
                    Util.delRow(detailMark);
                });
            }else{
                jQuery(this).remove();
            }
        });
    }
    render(){
        const { layoutStore } = this.props;
        const htmlStr = layoutStore.layoutSourceInfo.html;
        const reactComponent = htmlToReactParser.parseWithInstructions(htmlStr, this.isValidNode, this.processingInstructions());
        // console.log("htmlStr", htmlStr, "reactComponent", reactComponent);
        return reactComponent;
    }
    isValidNode = () =>{
        return true;
    }
    processingInstructions = () =>{
        const { layoutSourceInfo } = this.props.layoutStore;
        const fieldReg = new RegExp(/^\$(label|field|node)(-?\d+)\$$/);
        const detailReg = new RegExp(/^oTable(\d+)$/);
        return [
            {
                shouldProcessNode: (node) =>{
                    return node.name === "input" && node.attribs && node.attribs.id && node.attribs.id.match(fieldReg);
                },
                processNode: (node, children) =>{
                    const fieldArr = node.attribs.id.match(fieldReg);
                    const type = fieldArr[1];
                    let etype = 0;
                    etype = type === "label" ? 2 : etype;
                    etype = type === "field" ? 3 : etype;
                    etype = type === "node" ? 5 : etype;
                    const field = fieldArr[2];
                    const cellObj = { id:"0,0", field, etype};
                    let extendProps = {};
                    if(etype === 5)
                        extendProps.nodeMark = layoutSourceInfo.nodeMarkContent && layoutSourceInfo.nodeMarkContent[`node${field}`];
                    return <CellType ecId={`${this && this.props && this.props.ecId || ''}_CellType@2jq516@${etype}_${field}`} symbol="main" cellObj={cellObj} {...extendProps} />;
                }
            },
            {
                shouldProcessNode: (node) =>{
                    return node.name === "div" && node.attribs && node.attribs.id && node.attribs.id.match(detailReg);
                },
                processNode: (node) =>{
                    const detailIndex = parseInt(node.attribs.id.match(detailReg)[1]);
                    const dMark = `detail_${detailIndex+1}`;
                    const cellObj = { id:"0,0", etype:"7", detail:dMark};
                    return <CellType ecId={`${this && this.props && this.props.ecId || ''}_CellType@x298pa@${dMark}`} symbol="main" cellObj={cellObj} />;
                }
            },
            {
                shouldProcessNode: () =>{
				 	return true
				},
                processNode: processNodeDefinitions.processDefaultNode      //非匹配节点取默认，必须
            }
        ];
    }

}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/layout/SourceLayout.js